import React from 'react';
import { connect, ConnectedProps } from "react-redux";
import {
  Drawer,
  Box,
  IconButton,
  Typography,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { hideSlideout } from '../data/slideout';
import ContainerList from './mobile/planning/ContainerList';
import TerminalCallGrid from './Slideouts/TerminalCallGrid';
import VesselLoadStability from './partial/VesselLoadStability';

const mapStateToProps = (state) => ({
  slideout: state.slideout.slideout,
});

const mapDispatchToProps = {
  dispatchHideSlideout: hideSlideout,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type SlideoutProps = {} & ConnectedProps<typeof connector>;

const Slideout = ({ slideout, dispatchHideSlideout }: SlideoutProps) => {
  const isOpen = Boolean(slideout);

  const onCloseButtonClick = () => {
    dispatchHideSlideout();
  };

  const renderContent = () => {
    switch (slideout?.content) {
      case 'vesselloadstability':
        return <VesselLoadStability {...slideout.slideoutProps} />;
      case 'terminalcallgrid':
        return <TerminalCallGrid {...slideout.slideoutProps} />;
      case 'containerlist':
        return <ContainerList groupedByLoading={slideout.data} />;
      default:
        return null;
    }
  };

  const showHeader = slideout?.showHeader !== false; // default to true

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onCloseButtonClick}
      PaperProps={{
        sx: {
          width: slideout?.width ?? 300,
          boxShadow: 3,
          transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
        },
      }}
    >
      {slideout && (
        <>
          {showHeader && (
            <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                  py: 1.5,
                }}
              >
                <Typography variant="h6">{slideout.title ?? ""}</Typography>
                <IconButton onClick={onCloseButtonClick}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Divider />
            </>
          )}

          <Box sx={{ px: 2, py: 2, height: '100%', overflowY: 'auto' }}>
            {renderContent()}
          </Box>
        </>
      )}
    </Drawer>
  );
};

export default connector(Slideout);